import React from 'react';
import { Modal, BoxWrapper, Button } from 'components/Base';
import PersistentTable from './PersistentTable';
import { CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: '25rem'
  }
});

const PortfolioAllocationsModal = ({
  isOpen,
  isLoading = false,
  setIsOpen,
  modelPortfolioName,
  funds,
  modelPortfolios = [],
  columns,
  mpColumns = [],
  handleRowClick,
  parentRowData = [],
  goBackToParentMp
}: any) => {
  const classes = useStyles();
  return (
    <Modal isOpen={isOpen} closeModalFunc={() => setIsOpen(false)}>
      <BoxWrapper
        title={`${modelPortfolioName} -  Model Portfolio Allocations`}
        closeModal={() => {
          setIsOpen(false);
        }}
        style={{ width: '90vw' }}
      >
        {isLoading ? (
          <div className={classes.loaderWrapper}>
            <CircularProgress size="80px" />
          </div>
        ) : (
          <div style={{ padding: '0 1rem 1rem 1rem' }}>
            {funds && funds.length > 0 && (
              <>
                <h3>Funds</h3>
                <div style={{ maxHeight: '456px' }}>
                  <PersistentTable
                    tableId="overview_mpfunds"
                    columns={columns.filter(
                      (row: any) =>
                        ![
                          'risk_rating',
                          'growth_assets',
                          'risk_comfort_score'
                        ].includes((row as any).accessorKey)
                    )}
                    data={funds}
                    height="400px"
                  />
                </div>
              </>
            )}
            {modelPortfolios && modelPortfolios.length > 0 && (
              <div style={{ marginTop: '2rem' }}>
                <h3>Portfolios</h3>
                <div style={{ maxHeight: '456px' }}>
                  <PersistentTable
                    tableId="overview_mp"
                    columns={mpColumns}
                    data={modelPortfolios}
                    height="400px"
                    rowClick={(e: any) => handleRowClick(e, true)}
                  />
                </div>
              </div>
            )}
            <div style={{ margin: '1rem 0' }}>
              <Button
                color="primary"
                onClick={() =>
                  parentRowData.length > 0
                    ? goBackToParentMp()
                    : setIsOpen(false)
                }
              >
                {parentRowData.length > 0 ? 'Back' : 'Cancel'}
              </Button>
            </div>
          </div>
        )}
      </BoxWrapper>
    </Modal>
  );
};

export default PortfolioAllocationsModal;
